<template>
  <div class="report-view"></div>
</template>
<script>
export default {
  name: 'WaterMark',
  data() {
    return {
      watermarkText: 'SAMPLE REPORT'
    };
  },
  mounted() {
    this.addWatermark();
    this.addWatermark(-60);
    this.addWatermark(-120);
  },
  methods: {
    addWatermark(topOffset = 0) {
      const watermark = document.createElement('div');
      watermark.className = 'watermark';
      watermark.style.top = `${60 + topOffset}vh`;
      for (let i = 0; i < 50; i++) {
        const pTag = document.createElement('div');
        pTag.innerText = this.watermarkText;
        watermark.appendChild(pTag);
      }
      this.$el.appendChild(watermark);
    }
  }
};
</script>
<style>
.report-view {
  position: relative;
  width: 100%;
  height: 100%;
}
.watermark {
  position: fixed;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 45px;
  color: rgba(217, 217, 217, 0.6);
  pointer-events: none;
  white-space: pre-line;
  letter-spacing: 30px;
  line-height: 60px;
  z-index: 10000;
  transform: rotate(-30deg);
}
</style>
